<template>
  <tr>
    <td>
      <sui-button
        v-for="action in actionList"
        v-bind:content="action"
        v-on:click="buttonAction(action)"
        v-bind:key="action"
      />
    </td>
    <td>{{ item.name }}</td>
    <td>{{ item.modifiedAt | moment('DD-MM-YYYY') }}</td>
  </tr>
</template>

<script>
export default {
  name: 'ClassTableRow',
  props: ['item', 'actions'],
  computed: {
    actionList() {
      return this.actions || [];
    },
  },
  methods: {
    buttonAction(value) {
      this.$emit('action', { action: value, group: this.item });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/classes/ClassTableRow.vue